module.exports = __webpack_public_path__ + "static/img/antenatal2.9328a2ba.jpg";